'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUnansweredQuickReplyMessage = exports.getEmailCaptureMessageIndex = exports.shouldShowEmailCapture = undefined;

var _reselect = require('reselect');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

var _messageSelectors = require('conversations-core/selectors/messageSelectors');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _requestStatusSelectors = require('conversations-core/selectors/requestStatusSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OFFLINE_EMAIL_CAPTURE_INDEX = 1;

var shouldShowEmailCapture = exports.shouldShowEmailCapture = (0, _reselect.createSelector)([_widgetDataSelectors.isResponderOnline, _messageSelectors.shouldAskForEmail, _clientSelectors.getIsAgentReady, _widgetDataSelectors.getHasVisitorEmail, _requestStatusSelectors.getSendVisitorEmailSucceeded], function (online, askForEmail, isAgentReady, hasVisitorEmail, sendVisitorEmailSucceeded) {
  return Boolean(!online || askForEmail && (!hasVisitorEmail || sendVisitorEmailSucceeded) || isAgentReady === false);
});

var getEmailCaptureMessageIndex = exports.getEmailCaptureMessageIndex = (0, _reselect.createSelector)([_widgetDataSelectors.isResponderOnline, _conversationSelectors.getInitialOnlineModeConversation, _clientSelectors.getSessionStartedAt], function (online, initialWidgetConversation, sessionStartedAt) {
  if (!online) {
    return OFFLINE_EMAIL_CAPTURE_INDEX;
  }

  var messages = (0, _ConversationModel.getMessagesInHistory)(initialWidgetConversation);

  if (!messages || !sessionStartedAt) {
    return undefined;
  }

  var messageList = messages.filter(_ConversationalMessageModel.isConversationalMessage).toList();
  var awayMessageIndex = messageList.findIndex(function (message) {
    return (0, _ConversationalMessageModel.isFromVisitor)(message) && (0, _PubNubMessageModel.getClientTs)(message) >= sessionStartedAt;
  });

  return awayMessageIndex > 0 ? awayMessageIndex : undefined;
});

var hasUnansweredQuickReplyMessage = exports.hasUnansweredQuickReplyMessage = (0, _reselect.createSelector)([_conversationSelectors.getCurrentConversation], function (currentConversation) {
  var history = (0, _ConversationModel.getMessagesInHistory)(currentConversation);

  if (!history) {
    return false;
  }

  var conversationalMessages = history.filter(_ConversationalMessageModel.isConversationalMessage);

  var mostRecentMessage = conversationalMessages.last();
  var hasQuickReplyOptions = (0, _ConversationalMessageModel.getQuickReply)(mostRecentMessage);
  var from = (0, _ConversationalMessageModel.getFrom)(mostRecentMessage);
  var allowUserInput = (0, _ConversationalMessageModel.getAllowUserInput)(mostRecentMessage);

  return Boolean(hasQuickReplyOptions && from === _RoleTypes2.default.REP && allowUserInput === false);
});


//////////////////
// WEBPACK FOOTER
// ./js/selectors/chatSelectors.js
// module id = 211
// module chunks = 0 1